import { render, staticRenderFns } from "./biopharm.vue?vue&type=template&id=86729060&scoped=true&v-once=true"
import script from "./biopharm.vue?vue&type=script&lang=js"
export * from "./biopharm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86729060",
  null
  
)

export default component.exports